import { fetchTransactions } from '@/state/slice/transactionsSlice';
import { fetchRedemptions } from './state/slice/redemptionsSlice';
import { DateTime } from 'luxon';
import { FILTER_PERIOD_TIME } from './constants/date-time.constants';
import QueryTransaction from './interfaces/transaction';
import store from '@/state/index';

const NOTIFICATION_RINGTONE_PATH = '/notification-ringtone.wav';
const NOTIFICATION_VOLUME = 1.0;

const notificationAudio = new Audio(NOTIFICATION_RINGTONE_PATH);
notificationAudio.volume = NOTIFICATION_VOLUME;
notificationAudio.preload = 'auto';

const unlockAudio = () => {
	notificationAudio.muted = true;
	notificationAudio
		.play()
		.then(() => {
			notificationAudio.pause();
			notificationAudio.currentTime = 0;
			notificationAudio.muted = false;
		})
		.catch((err) => {
			notificationAudio.muted = false;
			console.warn('Audio unlock failed:', err);
		});
};

document.addEventListener('click', unlockAudio, { once: true });
document.addEventListener('touchstart', unlockAudio, { once: true });

export const playNotificationRingtone = () => {
	notificationAudio.currentTime = 0;
	notificationAudio.play().catch((err) => {
		console.warn('Unable to play notification ringtone:', err);
	});
};

const getContextFromPath = () => {
	return window.location.pathname.includes('/transactions') ? 'past' : 'home';
};

const getQueryFromPath = (context: string) => {
	if (context === 'past') {
		return {
			sort: 'createdAt',
			start: DateTime.now().minus({ days: FILTER_PERIOD_TIME.LAST_N_DAYS }).startOf('day').toJSDate(),
			end: DateTime.now().endOf('day').toJSDate(),
		} as QueryTransaction & { start: Date; end: Date };
	}
	return {
		sort: 'createdAt',
		start: DateTime.now().minus({ days: FILTER_PERIOD_TIME.RECENT_TXN }).startOf('day').toJSDate(),
	} as QueryTransaction;
};

navigator.serviceWorker.addEventListener('message', (event) => {
	if (!event.data.action) return;
	const query = {
		sort: 'createdAt',
		start: DateTime.now().minus({ days: FILTER_PERIOD_TIME.RECENT_TXN }).startOf('day').toJSDate(),
	} as QueryTransaction;

	switch (event.data.action) {
		case 'new-transaction-from-push-notification':
			if (event.data?.type === 'NEW_TRANSACTION') {
				playNotificationRingtone();
				const context = getContextFromPath();
				const contextQuery = getQueryFromPath(context);
				store.dispatch(fetchTransactions(contextQuery));
			}
			break;
		case 'new-redemption-from-push-notification':
			if (event.data?.type === 'NEW_REDEMPTION') {
				playNotificationRingtone();
				const context = getContextFromPath();
				const contextQuery = getQueryFromPath(context);
				store.dispatch(fetchTransactions(contextQuery));
				store.dispatch(fetchRedemptions(query));
			}
			break;
		case 'redirect-from-notificationclick':
			if (window.location.pathname !== event.data.url) {
				window.location.href = `${event.data.url}?tab=${event.data.query}`;
			}
			if (window.location.pathname === event.data.url && window.location.search !== `?tab=${event.data.query}`) {
				location.search = `?tab=${event.data.query}`;
			}
			window.focus();
			break;
		default:
			break;
	}
});
